import clienteAxios from "../config/axios";

export async function updGlobalSettings(gSettingsUpdated, companyImg, actionOverImg){
    let data = null;
    if(companyImg && actionOverImg){
        data = new FormData();
        data.append('gSettingsUpdated',JSON.stringify(gSettingsUpdated));
        data.append('prefijo', `companyImg`);
        data.append('actionOverImg', actionOverImg);
        data.append('photo',companyImg);
        return clienteAxios.put('/globalSettings/', data, {
            headers:{
                'Content-type':'multipart/form-data'
            }
        });
    }else{
        return clienteAxios.put('/globalSettings',{gSettingsUpdated, prefijo:'companyImg', actionOverImg});
    }
}

export async function getGlobalSettings () {
    return clienteAxios.get(`/globalSettings`);
}